import * as React from 'react';
import styled from 'styled-components';//emotion:chakuraUI(型付与)
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


type Props = {

}
export const UseNFTBackupcardButton: React.FC<Props> = (props) => {
  const [t, i18n] = useTranslation();
  const UseNFTBackupcardButtonComponent = styled.button`
    border: 0.5px solid rgba(239, 239, 239, 0.2);
    backdrop-filter: blur(50px);
    border-radius: 5px;
    background: linear-gradient(175.15deg, #F6F0F2 3.05%, #E89CEE 37.82%, #DAE4FF 68.31%, #B6CBFF 96.09%);
    font-weight: 700;
    box-sizing: border-box;
    width: 314px;
    height: 60px;
    box-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.6);
    margin-bottom: 10px;
    transition: all 0.5s;
    background-image: url('https://nfttopshot-template.onrender.com/template-images/btn-rainbow-square-bg.png');
    color: rgba(213, 182, 237, 1);

    &:hover {
      opacity: 0.8;
      background-color: rgba(255, 255, 255, .2);
    }
  `;

  const nav = useNavigate();
  return (
    <div id="usenftbackupcard">
      <UseNFTBackupcardButtonComponent 
        type="button"
        id="btn-default-mypage-backupuse”" 
        onClick={()=>nav('/5')}
      >
        {t('NFTバックアップカードを利用する')}
      </UseNFTBackupcardButtonComponent>
    </div>
  );
};